import * as actionTypes from '../actions'
import { catalogueUrlSegment } from '../../utils/catalogueUrl'

//TODO: en esta accion no va a llegar el listado de productos ni productos mas vendidos ni la cantidad de productos paraapenas este ese endpoint mover a una nueva accion
const initialState = {
  banners: [],
  categories: [],
  mostSelledProducts: [],
  cantProduct: '',
  loading: true,
  catalogueName: '',
  catalogueUrlName: '',
  catalogueId:'',
  clientName: '',
  companyName: '',
  contactData: {name: '', phone: ''},
  inactive: true,
  color:'#ADADAD',
  image: "",
  default_language: "ESP",
  whatsappButtonMarginBottom: undefined,
  footerMarginBottom: undefined,
  redirectInactive:false,
  inactive404:false,
  outstandingValid: false,
  outstandingData: [],
  currency: '',
  analytics: {
    "facebookPixelActive":false,
    "facebookPixelId": null,
    "googleAnalyticsActive":false,
    "googleAnalyticsId": null,
    "googleTagManagerActive":false,
    "googleTagManagerId": null
  },
  epaycoDeliveryProvider: false,
  providerDelivery: false,
  freeDelivery: false,
  shippingType: null,
  freeShippingMinAmount: null,
  pickupConfigurationId: 0,
  manage: 0,
  configDataOwner: {}
}

const homeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.START_HOME_IMAGE_CATALOGONAME: {
      return {
        ...state,
        catalogueId:action.payload.id,
        banners: action.payload.banners,
        categories: [],
        mostSelledProducts: [],
        cantProduct: 0,
        catalogueName: action.payload.name,
        // El nombre se muestra tal cual; la URL usa la forma normalizada
        catalogueUrlName: catalogueUrlSegment(action.payload.name),
        inactive:false,
        loading:false,// agregado en esta landing
        color: action.payload.color,
        contactEmail: action.payload.contactEmail,
        companyName: action.payload.companyName,
        indicativoPais:action.payload.indicativoPais,
        contactPhone: action.payload.contactPhone,
        image: action.payload.image,
        whatsappActive: action.payload.whatsappActive,
        currency: action.payload.currency,
        analytics: { ...action.payload.analytics },
        providerDelivery: action.payload.providerDelivery ? action.payload.providerDelivery : false,
        epaycoDeliveryProvider: action.payload.epaycoDeliveryProvider,
        freeDelivery: action.payload.freeDelivery,
        shippingType: action.payload.shippingType ?? null,
        freeShippingMinAmount: action.payload.freeShippingMinAmount ?? null,
        pickupConfigurationId: action.payload.pickupConfigurationId === "" ? 0 : action.payload.pickupConfigurationId,
        manage: action.payload.manage
      }
    }
    case actionTypes.START_HOME_CLIENT_NAME: {
      return {
        ...state,
        clientName: action.payload.companyName,
        contactData: {name: action.payload.companyName, phone: action.payload.cellPhone},
        loading: false,
        inactive:false
      }
    }
  
    case actionTypes.SHOW_LOADING: {
      return {
        ...state,
        loading: false,
        inactive:false
      }
    }
    case actionTypes.INACTIVE_CATALOGUE: {
      return {
        ...state,
        inactive:true,
        redirectInactive:true

      }
    }
    case actionTypes.INACTIVE_CATALOGUE_404: {
        return {
          ...state,
          inactive404:true,
          inactive:false,
          redirectInactive:true,
          loading:false
  
        }
    }
    case actionTypes.SET_OUTSTANDING: {
      return {
        ...state,
        outstandingValid:action.payload
      }
  }
  case actionTypes.SET_OUTSTANDINGDATA: {
    return {
      ...state,
      outstandingData:action.payload
    }
  }
  case actionTypes.SET_LANDING_LANGUAGE: {
    return {
      ...state,
      default_language: action.payload
    }
  }
    case actionTypes.WHATSAPP_BUTTON_CHANGE_POSITION: {
      return {...state, ...{ whatsappButtonMarginBottom: action.payload }}
    }
    case actionTypes.FOOTER_CHANGE_POSITION: {
      return {...state, ...{ footerMarginBottom: action.payload }}
    }
  
    case actionTypes.LOAD_DATA_CLIENT_OWNER: {
      return {
        ...state,
        configDataOwner: action.payload,
      }
    }
    default: {
      return state
    }
  }
}

export default homeReducer
